module.exports = __webpack_public_path__ + "static/media/Service.0beb174b.svg";